import * as React from 'react';
import PropTypes from 'prop-types';
import colors from '@strava/ui/colors';

const FistBumpNoDashesIconUnfilled = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={true}
  >
    <path
      d="M10.5 8.92578H9.52729L9.05659 7.04398L6.72069 6.45998C6.58009 6.40088 6.28909 6.30078 5.93749 6.30078C5.26559 6.30078 4.71779 6.65528 4.41409 7.26558L2.51569 10.5884L0.121094 11.7852L2.66989 17.5201L5.15919 16.2755H7.99999C10.2803 16.2755 10.6436 14.8146 10.6582 14.7521L10.6748 13.3429C10.9902 12.8986 11.1064 12.3453 11.1494 11.9806C11.7637 11.4791 11.9121 10.6784 11.7685 10.0685C11.6064 9.38488 11.0976 8.92588 10.4999 8.92588L10.5 8.92578ZM1.87889 12.416L2.64829 12.031L4.14459 15.2739L3.33009 15.6811L1.87889 12.416ZM10.1982 10.9971L9.82809 11.1846L9.82519 11.5982C9.82319 11.836 9.74709 12.399 9.52249 12.6231L9.32519 12.8209V14.4679C9.24509 14.5973 8.94919 14.9259 7.99999 14.9259H5.47139L3.73789 11.1689L5.60339 7.90238C5.65609 7.79838 5.79189 7.52008 6.19809 7.70418L7.94319 8.15728L8.13529 8.92588H6.49989V10.2755H10.4179C10.4501 10.339 10.4872 10.4703 10.4628 10.6256C10.4355 10.798 10.3466 10.923 10.1982 10.9972V10.9971Z"
      fill={color}
    />
    <path
      d="M21.4843 10.5884L19.6034 7.29878C19.2821 6.65518 18.7343 6.30078 18.0624 6.30078C17.7108 6.30078 17.4198 6.40088 17.2792 6.45998L14.9433 7.04398L14.4726 8.92578H13.4999C12.9022 8.92578 12.3935 9.38478 12.2313 10.0684C12.0877 10.6783 12.2362 11.479 12.8504 11.9805C12.8934 12.3452 13.0096 12.8985 13.325 13.3428V14.6006L13.3416 14.752C13.3562 14.8145 13.7195 16.2754 15.9998 16.2754H18.8406L21.3299 17.52L23.8787 11.7851L21.4842 10.5883L21.4843 10.5884ZM14.6747 14.478V12.8208L14.4774 12.623C14.2528 12.3989 14.1766 11.8359 14.1747 11.6005V11.1835L13.8017 10.997C13.6533 10.9228 13.5644 10.7978 13.5371 10.6254C13.5127 10.4701 13.5498 10.3388 13.582 10.2753H17.5V8.92568H15.8646L16.0567 8.15708L17.6641 7.75518L17.793 7.70828C18.2041 7.51978 18.3438 7.79768 18.4141 7.93538L20.2616 11.1681L18.5302 14.9257H16C15.0293 14.9257 14.7412 14.5819 14.6748 14.4779L14.6747 14.478ZM20.6698 15.6811L19.8564 15.2744L21.351 12.0307L22.1209 12.416L20.6697 15.6811H20.6698Z"
      fill={color}
    />
  </svg>
);

FistBumpNoDashesIconUnfilled.defaultProps = {
  color: colors.O50_STRAVA_ORANGE,
  size: 24
};
FistBumpNoDashesIconUnfilled.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number
};

export default FistBumpNoDashesIconUnfilled;
